<div class="content-wrapper">
  <app-profile-title [title]="'public.profile.myAccountTitle' | translate" [showMenu]="true"/>

  <app-collapse-panel [title]="'public.profile.myProfileTitle' | translate"
                      [startsOpened]="openPanels.includes('profile')"
                      #profile>
    <app-profile-details [name]="customerProfile?.name" [phone]="customerProfile?.phoneNumber"
                         [email]="customerProfile?.email"/>
    <app-profile-addresses [customerProfile]="customerProfile"/>
  </app-collapse-panel>

  <!-- This panel is currently not implemented, but kept for future use -->
  <app-collapse-panel class="mb-3" [title]="'My Orders' | translate" [startsOpened]="false"
                      #orders *ngIf="false">
    <app-profile-orders/>
  </app-collapse-panel>

  <app-collapse-panel [title]="'public.profile.loyaltyPointsTitle' | translate"
                      [startsOpened]="openPanels.includes('loyalty')"
                      *ngIf="loyaltyEnabled"
                      #loyalty>
    <app-profile-loyalty-points/>
  </app-collapse-panel>
</div>
